import withAemIntegration from "../../../withAemIntegration";
import serviceParser, { dealerDataMap } from "../../../utils/serviceParser";

import loadable from "../../../utils/loadable";
const DividerLine = loadable(() =>
  import("@lexus.com/ui/dist/modules/DividerLine")
);
const Component = loadable(() =>
  import("@lexus.com/ui/dist/components/DealerContacts")
);

const DealerKeyContactsEditConfig = {
  emptyLabel: "DealerKeyContacts",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const buildTiles = (contacts) => {
  return contacts.map((contact, index) => {
    const newContactObj = {
      id: `Tile #${index + 1}`,
      heading: contact.contactName,
      description: contact.contactTitle,
    };
    if (contact.contactImage) {
      newContactObj.media = {
        image: {
          desktop: {
            type: "desktop",
            src: contact.contactImage,
            alt: contact.contactName,
          },
        },
      };
    }
    if (contact.directPhone) {
      newContactObj.ctaPhone = {
        text: contact.directPhone,
        href: "tel:+1" + contact.contactPhone,
        type: "text",
      };
    }
    if (contact.contactEmail) {
      newContactObj.ctaEmail = {
        text: contact.contactEmail,
        href: "mailto:" + contact.contactEmail,
        type: "text",
      };
    }
    return newContactObj;
  });
};

const transformData = (props) => {
  return {
    id: "DealerKeyContacts",
    heading: serviceParser(props.heading, dealerDataMap),
    textColor: props.textColor || "#000",
    tiles: buildTiles(window.LEXUS.dealerData.dealerKeyContacts || []),
    mobileCarousel: props.mobileCarousel || false,
    disclaimerMessage: props.disclaimerText || "",
  };
};

const DealerKeyContacts = (props) => {
  const data = transformData(props);

  return window.LEXUS.dealerData.dealerKeyContacts?.length > 0 ? (
    <>
      <Component {...data} />
      <DividerLine />
    </>
  ) : null;
};
export default withAemIntegration(
  "lexus/components/dealer-details/dealer-key-contacts"
)(DealerKeyContacts, DealerKeyContactsEditConfig);
